/**
* Checklist Cutout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Checklist Cutout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'checklist-cutout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.checklist-cutout' ).each( function( key, component ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).find( '.checklist-cutout__items' ).addClass( 'is-loaded' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( this ).find( '.checklist-cutout__items' ).addClass( 'is-loaded' );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'checklist-cutout', COMPONENT );
} )( app );
